/**
 * ErrorBreakdown 组件
 *
 * 显示各供应商的错误统计详情。
 */

import React from 'react';
import type { SearchErrorItem } from '../../../services/searchAdminApi';

interface ErrorBreakdownProps {
  errors: SearchErrorItem[];
  loading: boolean;
}

export const ErrorBreakdown: React.FC<ErrorBreakdownProps> = ({
  errors,
  loading,
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="animate-pulse space-y-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-4 bg-gray-200 rounded" />
          ))}
        </div>
      </div>
    );
  }

  if (errors.length === 0) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6 text-center">
        <span className="text-green-600 text-sm">无错误记录</span>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div className="p-4 border-b border-gray-200">
        <h3 className="text-sm font-medium text-gray-800">错误统计</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50">
              <th className="text-left p-3 font-medium text-gray-600">
                供应商
              </th>
              <th className="text-left p-3 font-medium text-gray-600">密钥</th>
              <th className="text-right p-3 font-medium text-gray-600">
                错误数
              </th>
              <th className="text-right p-3 font-medium text-gray-600">
                失败数
              </th>
              <th className="text-right p-3 font-medium text-gray-600">
                失败率
              </th>
              <th className="text-left p-3 font-medium text-gray-600">
                最近错误
              </th>
            </tr>
          </thead>
          <tbody>
            {errors.map((e, idx) => (
              <tr
                key={`${e.provider_name}-${e.key_index}`}
                className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
              >
                <td className="p-3 font-medium">{e.provider_name}</td>
                <td className="p-3">#{e.key_index}</td>
                <td className="text-right p-3">
                  <span
                    className={
                      e.error_count > 10 ? 'text-red-600 font-medium' : ''
                    }
                  >
                    {e.error_count}
                  </span>
                </td>
                <td className="text-right p-3">{e.total_failures}</td>
                <td className="text-right p-3">
                  <span
                    className={
                      e.failure_rate > 0.5
                        ? 'text-red-600'
                        : e.failure_rate > 0.2
                          ? 'text-yellow-600'
                          : 'text-green-600'
                    }
                  >
                    {(e.failure_rate * 100).toFixed(1)}%
                  </span>
                </td>
                <td className="p-3 max-w-xs truncate text-gray-500">
                  {e.last_error || '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ErrorBreakdown;
